<template>
  <div class="view pa24">
    <div v-if="accountMap && accountMap.state == 1">
      <table class="align-cen-table textc table table-hover table-bordered bgf6f9fa fixed-table text-ellipsis">
        <thead>
          <tr>
            <th>{{ $t('miniprogram', 'miniProgramName') }}</th>
            <th>{{ $t('miniprogram', 'appId') }}</th>
            <th>{{ $t('miniprogram', 'authTime') }}</th>
          </tr>
        </thead>
        <tbody class="bgfff">
          <tr>
            <td>{{ accountMap.appName }}</td>
            <td>{{ accountMap.appId }}</td>
            <td>{{ accountMap.createTime | getDataTimeSec('yyyy-MM-dd hh:mm:ss') }}</td>
          </tr>
        </tbody>
      </table>
      <el-button type="primary" @click="resetAuthorization">{{ $t('miniprogram', 'resetAuthorization') }}</el-button>
    </div>
    <el-form v-else :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm">
      <el-form-item :label="$t('miniprogram', 'appName')" prop="appName">
        <el-col>
          <el-input :placeholder="$t('miniprogram', 'pleaseEnterMiniProgramName')" v-model="ruleForm.appName"></el-input>
          <p>
            {{ $t('miniprogram', 'miniProgramNameDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'appId')" prop="appId">
        <el-col>
          <el-input type="text" :placeholder="$t('miniprogram', 'pleaseEnterMiniProgramAppId')" v-model="ruleForm.appId"></el-input>
          <p>
            {{ $t('miniprogram', 'miniProgramAppIdDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'appSecret')" prop="appSecret">
        <el-col>
          <el-input type="text" :placeholder="$t('miniprogram', 'pleaseEnterMiniProgramAppSecret')" v-model="ruleForm.appSecret" maxlength="32"></el-input>
          <p>
            {{ $t('miniprogram', 'miniProgramAppSecretDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :lg="11">
          <el-button type="primary" @click="authorization">{{ $t('miniprogram', 'authorization') }}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { componentloginpage } from "@/api/authorization"
import { componentCallBack } from '@/api/wechat'
import { getDataTimeSec } from "@/utils";
import { showLoading, hideLoading } from '@/utils/loading'
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  props: {
    accountMap: {
      default: {}
    }
  },
  data() {
    return {
      ruleForm: {
        appName: "",
        appId: "",
        appSecret: "",
      },
      rules: {
        appName: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterMiniProgramName'), trigger: "blur" },
        ],
        appId: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterMiniProgramAppId'), trigger: "blur" },
        ],
        appSecret: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterMiniProgramAppSecret'), trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    console.log("accountMap", this.accountMap)
    console.log(this.$route.query)
    if (this.$route.query.auth_code) {
      //oem授权回调
      let userAppId = localStorage.getItem('userAppId') || ''
      if (userAppId) {
        showLoading();
        componentCallBack({ authCode: this.$route.query.auth_code, appId: userAppId }).then(res => {
          localStorage.removeItem('userAppId');
          this.getAppInfo();
          hideLoading();
          this.$message.success(this.$t('miniprogram', 'userAuthSuccess'))
        })
        .catch(err => {
          console.log(err);
          hideLoading();
          this.$message.error(this.$t('miniprogram', 'userAuthFailed'))
        });
      }
    }
  },
  methods: {
    authorization() {
      let data = {
        appName: this.ruleForm.appName,
        appId: this.ruleForm.appId,
        appSecret: this.ruleForm.appSecret,
        accountType: 1 //用户1
      }
      componentloginpage(data).then(res => {
        localStorage.setItem('userAppId', this.ruleForm.appId)
        window.open(res.data);
      })
    },
    getAppInfo() {
      this.$emit('getAppListInfo')
    },
    resetAuthorization() {
      let accountId = ''
      if (this.accountMap.accountType == 1) {
        accountId = this.accountMap.accountId || 0
      }
      if (!accountId) {
        this.$message.error(this.$t('miniprogram', 'notAuthorized'))
        return
      }
      this.$emit('resetAuthorization', accountId)
    }
  }
};
</script>

<style lang="scss" scoped>
table th {
  background: #F7FAFA;
}

tbody:hover {
  background: #F7FAFA;
}

table tr {
  height: 50px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table {
  table-layout: fixed;
}

.textc {
  text-align: center;
}

.bgf6f9fa {
  background: #F6F9FA;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

body * {
  font-family: "Microsoft YaHei UI";
}

table {
  border-collapse: collapse;
}

* {
  outline: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}
.el-input {
  width: 500px;
}
</style>
